import i18n from 'modules/core/lib/i18n'

import { PROGRESS_STATUS } from 'modules/goals/store/models/Goal'

export default function goalsProgressStatus(list: string[]): string[] {
  const values = {
    [PROGRESS_STATUS.achieved]: i18n.t(
      'custom_reports.especial_filters.goals_goals_progress_status.options.achieved'
    ),
    [PROGRESS_STATUS.onTrack]: i18n.t(
      'custom_reports.especial_filters.goals_goals_progress_status.options.on_track'
    ),
    [PROGRESS_STATUS.atRisk]: i18n.t(
      'custom_reports.especial_filters.goals_goals_progress_status.options.at_risk'
    ),
    [PROGRESS_STATUS.progressing]: i18n.t(
      'custom_reports.especial_filters.goals_goals_progress_status.options.progressing'
    ),
    [PROGRESS_STATUS.overAchieved]: i18n.t(
      'custom_reports.especial_filters.goals_goals_progress_status.options.over_achieved'
    ),
    [PROGRESS_STATUS.notAchieved]: i18n.t(
      'custom_reports.especial_filters.goals_goals_progress_status.options.not_achieved'
    ),
  }

  return list.map((value) => values[value]).filter((value): value is string => value !== undefined)
}
